module.exports = __webpack_public_path__ + "static/media/capgeminiLogo.8b48cd2c.png";